export const isQlLogicalOperator = (operator) => ['AND', 'OR'].includes(operator);
